App.directive('formAssuredOrganizationTpl', ['$window', 'Config', '$filter', 'statesService', '$q', function ($window, Config, $filter, statesService, $q) {
    return {
    	restrict: 'AEC',
        scope: {
            form: '=',
            model: '=',
            prefix: '@',
            withSibling: '=',
            forWorker: '=?',
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/form-assured-organization-tpl.html',
        link: function(scope) {

            var getResults = function(query) {
                var deferred = $q.defer();

                statesService.dataCityLists({
                    name: query
                }).then(function(data) {
                    deferred.resolve(data.data);
                });

                return deferred.promise;
            };

            // ##### LOCALIZATION FILTER ##### //
            scope.querySearchLocalization = function(query) {
                if (!query) {
                    return;
                }
                  
                return getResults(query).then(function(results) {
                    return results;
                });
            };
        }
    };
}]);